module.exports = __webpack_public_path__ + "053256db9458c2452f8f686652f520ad.jpg";